import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { Active, ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, GuidDefault } from "utils/Constant";
import { ApiDeleteExpense, ApiGetExpenseList, ApiGetSystemSettingById, ApiInsertExpense } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import SearchButton from "components/Button/SearchButton";
import Dropdown from "components/Input/Dropdown";
import moment from "moment";
import { money } from "utils/helpers";
import DatePicker from "components/Input/DatePicker";
import SaveButton from "components/Button/SaveButton";

export default function Expenses(){
    let navigate = useNavigate()

    const { fetch: insertExpense } = useFetch(ApiInsertExpense)
    const { fetch: deleteExpense } = useFetch(ApiDeleteExpense)
    const { data: expenseList, fetch: getExpenseList } = useFetch(ApiGetExpenseList)

    const { fetch: getStatusList } = useFetch(ApiGetSystemSettingById)
    const { fetch: getMonthList } = useFetch(ApiGetSystemSettingById)
    const { fetch: getYearList } = useFetch(ApiGetSystemSettingById)
    const { fetch: getExpenseTypeList } = useFetch(ApiGetSystemSettingById)

    const [accMonth, setAccMonth] = useState(EmptyString)
    const [accYear, setAccYear] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    
    const [expenseId, setExpenseId ] = useState(EmptyString)
    const [expenseDate, setExpenseDate ] = useState(EmptyString)
    const [expense, setExpense ] = useState(EmptyString)
    const [remark, setRemark ] = useState(EmptyString)
    const [amount, setAmount ] = useState(EmptyString)

    // Dropdown
    const [statusOptions, setStatusOptions] = useState([])
    const [accMonthOptions, setAccMonthOptions] = useState([])
    const [accYearOptions, setAccYearOptions] = useState([])
    const [expenseOptions, setExpenseOptions ] = useState(EmptyString)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState(false)
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {        
        setExpenseDate(new Date())
        setLoading(true)

        Promise.all([
            fGetStatusList(),
        ]).then(() => {
            Promise.all([
                fGetMonthList()
            ]).then(() => {
                Promise.all([
                    fGetYearList()
                ]).then(() => {
                    setAccMonth(moment(new Date()).format("M"))
                    setAccYear(moment(new Date()).format("yyyy"))
                    fGetExpenseTypeList()
                    fGetExpenseList()
                })
            }).finally(() => {
                
            })
        }).finally(() => {
            setLoading(false)
        })
    },[])

    // Function Button
    function fSaveBtnClick(){
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })
                    setLoading(true)

                    Promise.all([
                        fInsertExpense()
                    ]).then(() => {
                        setLoading(false)
                    })                    
                }
            }
        })        
    }
    function fDeleteBtnClick(expenseId){
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })
                    setLoading(true)
                    Promise.all([
                        fDeleteExpense(expenseId)
                    ]).then(() => {
                        setLoading(false)
                    })
                    
                }
            }
        })
    }
    function fSearchBtnClick(){
        fGetExpenseList()
    }

    // Function Api Call
    async function fInsertExpense(){
        await insertExpense({
            data: {
                kostId: localStorage.getItem("KostId"),
                expenseDate: expenseDate,
                expense: expense,
                amount: amount.replaceAll(",", ""),
                remark: remark,
                updateId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                            setSuccessModal({ isOpen: false })
                            fClearForm()
                            fGetExpenseList()
                        }
                    } 
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        }).finally(() => {
        })
    }
    async function fGetExpenseList(){
        await getExpenseList({
            data: {
                kostId: localStorage.getItem("KostId"),
                month: accMonth === "" ? moment(new Date()).format("M") : accMonth,
                year: accYear === "" ? moment(new Date()).format("yyyy") : accYear,
                status: status === "" ? "1" : status
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        }).finally(() => {
        })
    }
    async function fDeleteExpense(expenseId){
        await deleteExpense({
            data: {
                kostId: localStorage.getItem("KostId"),
                expenseId: expenseId,
                updateId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { setSuccessModal({  isOpen: false }) }} })
                fGetExpenseList()
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetStatusList(){
        await getStatusList({
            data: {
                kostId: GuidDefault,
                systemId: "Status"
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let tempArray = []

                for (let i = 0; i < response.data.length; i++){
                    tempArray.push({ label: response.data[i].systemText, value: response.data[i].systemValue })
                }

                setStatusOptions(tempArray)
                setStatus(tempArray[0].value)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetMonthList(){
        await getMonthList({
            data: {
                kostId: GuidDefault,
                systemId: "Month"
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let tempArray = []

                for (let i = 0; i < response.data.length; i++){
                    tempArray.push({ label: response.data[i].systemText, value: response.data[i].systemValue })
                }

                setAccMonthOptions(tempArray)
                setAccMonth(tempArray[0].value)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetYearList(){
        await getYearList({
            data: {
                kostId: GuidDefault,
                systemId: "Year"
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let tempArray = []

                for (let i = 0; i < response.data.length; i++){
                    tempArray.push({ label: response.data[i].systemText, value: response.data[i].systemValue })
                }

                setAccYearOptions(tempArray)
                setAccYear(tempArray[0].value)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetExpenseTypeList(){
        await getExpenseTypeList({
            data: {
                kostId: GuidDefault,
                systemId: "ExpenseType"
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let tempArray = []

                for (let i = 0; i < response.data.length; i++){
                    tempArray.push({ label: response.data[i].systemText, value: response.data[i].systemValue })
                }

                setExpenseOptions(tempArray)
                setExpense(tempArray[0].value)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function Grid
    function fClearForm(){
        setRemark(EmptyString)
        setAmount(EmptyString)
    }    

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">Expenses</span>
            </div>
            <hr />

            {/* Form */}
            <div className="flex flex-col gap-3 justify-between mt-5 border rounded-md p-4">
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 w-full">
                    <div className="w-auto sm:w-[240px]">
                        <span>Expense Id</span>
                    </div>
                    <div className="px-2 hidden sm:block">
                        <span>:</span>
                    </div>
                    <div className="w-full sm:w-72">
                        <input className="input" value={ expenseId } onChange={(e) => { setExpenseId(e.target.value) }} disabled={ true } />
                    </div>                    
                </div>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 w-full">
                    <div className="w-auto sm:w-[240px]">
                        <span>Expense Date</span>
                    </div>
                    <div className="px-2 hidden sm:block">
                        <span>:</span>
                    </div>
                    <div className="w-full sm:w-72">
                        <DatePicker className="w-full h-[42px] bg-white" value={ expenseDate } onChange={(e) => { setExpenseDate(e) }} />
                    </div>                    
                </div>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 w-full">
                    <div className="w-[240px]">
                        <span>Expense</span>
                    </div>
                    <div className="px-2 hidden sm:block">
                        <span>:</span>
                    </div>
                    <div className="w-full sm:w-72">
                        <Dropdown options={ expenseOptions } value={ expense } onChange={(e) => { setExpense(e.value) }} />
                    </div>                    
                </div>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 w-full">
                    <div className="w-[240px]">
                        <span>Remark</span>
                    </div>
                    <div className="px-2 hidden sm:block">
                        <span>:</span>
                    </div>
                    <div className="w-full sm:w-72">
                        <input className="input" value={ remark } onChange={(e) => { setRemark(e.target.value) }} />
                    </div>                    
                </div>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 w-full">
                    <div className="w-[240px]">
                        <span>Amount</span>
                    </div>
                    <div className="px-2 hidden sm:block">
                        <span>:</span>
                    </div>
                    <div className="w-full sm:w-72 flex items-center">
                        <div className="px-3 py-2 bg-slate-100 border-l border-y rounded-l-md">
                            <span>Rp</span>
                        </div>
                        <input className="px-4 py-2 rounded-r-md w-full border border-app-light-grey" value={ amount } onInput={(e) => { setAmount(money(e.target.value))}} />
                    </div>
                </div>
                <div className="flex justify-end items-center gap-2 w-full">
                    <SaveButton className="" onClick={() => { fSaveBtnClick() }} visible="true" />                
                </div>
            </div>
           
            {/* Data */}
            <div className="border rounded-md mt-4 p-4"> 
                <div className="flex flex-col sm:flex-row justify-between w-full">
                    <div className="flex flex-col sm:flex-row gap-4 w-full">
                        <div className="flex flex-col gap-2 w-full sm:max-w-[280px]">
                            <span>Expense Periode</span>
                            <div className="flex gap-2">
                                <Dropdown className="w-full" value={ accMonth } options={ accMonthOptions } onChange={(e) => { setAccMonth(e.value) }} />
                                <Dropdown className="w-32" value={ accYear } options={ accYearOptions } onChange={(e) => { setAccYear(e.value) }} />
                            </div>
                        </div>
                        
                        <div className="flex flex-col gap-2 w-full sm:max-w-[200px]">
                            <span>Status</span>
                            <Dropdown value={ status } options={ statusOptions } onChange={(e) => { setStatus(e.value) }} />
                        </div>
                    </div>

                    <div className="">
                        <div className="flex items-end justify-end h-full mt-4 sm:mt-0">
                            <SearchButton onClick={() => { fSearchBtnClick() }} />
                        </div>
                    </div>
                </div>
               
                <div className="mt-5">
                    <table className="w-full border bg-white">
                        <thead>
                            <tr className="h-12">
                                <th className="font-semibold w-16 hidden sm:table-cell">No</th>
                                <th className="font-semibold text-left px-2">Expense Date</th>
                                <th className="font-semibold text-left px-2">Expense</th>
                                <th className="font-semibold text-center px-2 w-auto sm:w-48">Amount</th>
                                <th className="font-semibold text-center px-2 hidden sm:table-cell">Remark</th>
                                <th className="font-semibold text-center px-2 hidden sm:table-cell">Status</th>
                                <th className="font-semibold w-24 hidden sm:table-cell">Action</th>
                            </tr>
                        </thead>
                        <tbody className="border">
                            {expenseList?.data?.expenseList?.map((data, i) => {
                                return(
                                    <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                        <td className="text-center hidden sm:table-cell">{ data.rowNumber }</td>
                                        <td className="px-2">
                                            <span>{ moment(data.expenseDate).format("DD MMM yyyy") }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.expense }</span>
                                        </td>
                                        <td className="px-2 text-right">
                                            <span>Rp { money(data.amount) }</span>
                                        </td>
                                        <td className="px-2 text-center hidden sm:table-cell">
                                            <span>{ data.remark }</span>
                                        </td>
                                        <td className="px-2 text-center hidden sm:table-cell">
                                            <span>{ data.status }</span>
                                        </td>
                                        <td className="flex justify-center py-2 gap-2 px-0 sm:px-2 hidden sm:table-cell">
                                            <button className={`button flex gap-2 ${ data.status === Active ? "block" : "hinnden" }`} onClick={() => fDeleteBtnClick( data.expenseId )}>
                                                <TrashIcon className="w-4 fill-white" />
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                        <tfoot>
                            <tr className="my-2 row h-10 border-y">
                                <td className="px-2 hidden sm:table-cell"></td>
                                <td className="px-2"></td>
                                <td className="px-2"></td>
                                <td className="px-2 text-right font-semibold">Rp { expenseList === null ? "" : money(expenseList?.data?.totalExpense)  }</td>
                                <td className="px-2 hidden sm:table-cell"></td>
                                <td className="px-2 hidden sm:table-cell"></td>
                                <td className="px-2 hidden sm:table-cell"></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading ? (<LoadingModal />) : (<div />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}